import FeaturesTestimonialLauren from '@listening/assets/astro/images/new-design-25/homepage/features-testimonial-1.png';
import FeaturesTestimonialAlex from '@listening/assets/astro/images/new-design-25/homepage/features-testimonial-2.png';
import FeaturesTestimonialMelonie from '@listening/assets/astro/images/new-design-25/homepage/features-testimonial-3.png';
import * as m from '@/paraglide/messages';
import { RowOneFeatures } from './Features/RowOneFeatures';
import { RowSecondFeatures } from './Features/RowSecondFeatures';

const userComments: {
  comment: () => string;
  name: string;
}[] = [
  {
    comment: () => m.testimonial_features_lauren(),
    name: 'Lauren Fratamico',
  },
  {
    comment: () => m.testimonial_features_alexp(),
    name: 'AlexP1799',
  },
  {
    comment: () => m.testimonial_features_melonie(),
    name: 'Melonie Boser',
  },
];
export function Features() {
  return (
    <section
      aria-labelledby='features-heading'
      className='relative bg-azure-525/5'
    >
      <div className='relative mx-auto w-full max-w-[1600px] px-4 py-12 sm:px-6 sm:py-16 md:py-20 lg:px-[72px] lg:py-24'>
        <h2
          className='mb-4 text-3xl font-bold sm:text-4xl md:text-5xl lg:mb-6 lg:text-6xl'
          id='features-heading'
        >
          {m.homepage_features_heading()}
        </h2>
        <p className='max-w-5xl text-base font-light'>
          {m.homepage_features_description()}
        </p>

        <div
          aria-label='Feature list'
          className='mt-8 grid grid-cols-1 gap-4 sm:mt-12 sm:gap-5 lg:mt-16 lg:gap-6'
          role='list'
        >
          <RowOneFeatures />
          <RowSecondFeatures />
        </div>

        <div
          aria-label='User testimonials'
          className='mt-16 flex flex-wrap items-start gap-6'
          role='complementary'
        >
          {userComments.map(({ comment, name }, index) => (
            <div
              className='group relative basis-full rounded-xl border border-mist-880 px-8 py-6 shadow-md transition-shadow duration-300 hover:shadow-xl sm:basis-[calc(50%-12px)] lg:basis-[calc(33.333%-16px)]'
              key={comment()}
              role='article'
            >
              <blockquote>
                <p className='text-base text-navy-220/70'>{comment()}</p>
                <footer className='mt-8 flex items-center gap-3'>
                  <img
                    alt={`${name}'s avatar`}
                    className='size-12 rounded-full object-cover'
                    src={
                      index === 0
                        ? FeaturesTestimonialLauren
                        : index === 1
                          ? FeaturesTestimonialAlex
                          : FeaturesTestimonialMelonie
                    }
                  />
                  <cite className='text-sm font-semibold text-navy-220 sm:text-lg'>
                    {name}
                  </cite>
                </footer>
              </blockquote>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
